import React from 'react';
import PropTypes from 'prop-types';
import {
  useTheme,
} from '@material-ui/core';
import { Chart } from 'react-google-charts';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import SeedAuthenticationRepository from '../../repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';
import ChartRepository from '../../repository/ChartRepository';
import { formatDateForApi } from '../../data/api/api-helpers';
import MyInputDate from '../../form/field/MyInputDate';
import pageUtilsPropTypes from '../page-prop-types';


const SeedChartsPage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
    pageUtils,
  } = props;
  const theme = useTheme();

  const [data, setData] = React.useState(null);
  const [isReady, setIsReady] = React.useState(false);
  const [repo] = React.useState(new ChartRepository());
  const lastWeek = new Date();
  lastWeek.setDate(lastWeek.getDate() - 7);
  const [start, setStart] = React.useState(new Date(lastWeek));
  const [end, setEnd] = React.useState(new Date());

  React.useEffect(() => {
    pageUtils.loadSomethingSilentRaw(
      () => repo.getHistoryExchange(undefined, undefined, start, end),
      (payload) => {
        const d = [['Day', 'Exchange Rate']];
        const i = new Date(start);
        let prevValue = 0;
        while (i.getTime() <= end.getTime()) {
          const key = formatDateForApi(i);
          if (key in payload.rates) {
            d.push([new Date(i), payload.rates[key].IDR]);
            prevValue = payload.rates[key].IDR;
          } else {
            d.push([new Date(i), prevValue]);
          }
          i.setDate(i.getDate() + 1);
        }
        console.log(d);
        setData(d);
        setIsReady(true);
      },
      (error) => {
        console.log(error);
      },
      () => {
      },
    );

    return () => {

    };
  }, [start, end, pageUtils, repo]);

  return (
    <Dashboard3Drawers
      titleId="seed.charts.title"
      routes={drawerRoutes}
      AuthenticationRepository={AuthenticationRepository}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      breadcrumbs={[
        {
          id: 'home',
          href: '/',
          titleId: 'seed.home.title',
        },
        {
          id: 'chart',
          titleId: 'seed.charts.title',
        },
      ]}
    >
      <MyInputDate
        name="start"
        value={start}
        onChange={(e) => setStart(e.target.value)}
      />
      <MyInputDate
        name="end"
        value={end}
        onChange={(e) => setEnd(e.target.value)}
      />
      <div style={{ display: 'flex' }}>
        {
          isReady ? (
            <Chart
              chartType="AreaChart"
              data={data}
              loader={<div>Loading chart...</div>}
              width="100%"
              height="400px"
              legendToggle
              options={{
                hAxis: {
                  format: 'MMM dd, yyyy',
                  gridlines: {
                    color: theme.palette.background.paper,
                  },
                },
                vAxis: {
                  gridlines: {
                    color: theme.palette.background.paper,
                  },
                  title: 'IDR',
                },
                pointSize: 2,
              }}
            />
          ) : 'Loading data...'
        }
      </div>
    </Dashboard3Drawers>
  );
};

SeedChartsPage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  drawerRoutes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
  pageUtils: pageUtilsPropTypes.isRequired,
};

SeedChartsPage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  applicationName: 'react-seed',
  logo: seedLogo,
  drawerRoutes: seedDrawerRoutes,
  icons: seedDashboard3DrawersIcons,
};

export default SeedChartsPage;
